import { useEffect, useState } from "react";

import {
  Typography,
  Fade,
  Container,
  Box,
  IconButton,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { Close } from "@mui/icons-material";
import { UnifiedRegister } from "./customComponents";
import { Loading } from "../../components";
import { appColors } from "../../constants/theme";

const Register = () => {
  const { userType } = useParams();
  const navigate = useNavigate();
  const [showVerify, setShowVerify] = useState(false);
  const [loading, setLoading] = useState(false);

  // Güvenlik: sayfa her mount olduğunda loading'i kapat
  useEffect(() => {
    setLoading(false);
    return () => setLoading(false);
  }, []);


  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: appColors.bgMuted,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Loading component - saydam background ile blur efekti */}
      {loading && <Loading backdrop={true} />}
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Fade in timeout={800}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              borderRadius: "16px",
              background: appColors.white,

              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Header Section - Green Gradient */}
            <Box
              sx={{
                background: `linear-gradient(135deg, ${appColors.primary} 0%, ${appColors.primaryTeal} 100%)`,
                padding: "2rem",
                textAlign: "center",
                position: "relative",
              }}
            >
              <IconButton
                onClick={() => navigate('/login')}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  color: appColors.white,
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                  },
                  transition: "all 0.2s ease",
                  zIndex: 10,
                }}
              >
                <Close sx={{ fontSize: 20 }} />
              </IconButton>

              {/* Medilya Logo/Icon */}
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: appColors.white,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 1rem",

                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: appColors.primary,
                  }}
                >
                  M
                </Typography>
              </Box>

              <Typography
                variant="h4"
                sx={{
                  color: appColors.white,
                  fontWeight: 700,
                  mb: 1,
                }}
              >
                Medilya
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  color: appColors.white,
                  fontWeight: 600,
                  mb: 1,
                }}
              >
                Uzman Kayıt
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "rgba(255, 255, 255, 0.9)",
                  fontSize: "0.9rem",
                }}
              >
                Danışan takip sisteminize hızlı kayıt
              </Typography>
            </Box>

            {/* Form Section */}
            <Box sx={{ padding: "2rem" }}>
              <UnifiedRegister
                userType={userType}
                showVerify={showVerify}
                setShowVerify={setShowVerify}
                loading={loading}
                setLoading={setLoading}
              />
            </Box>

            {/* Footer Security Info */}
            <Box
              sx={{
                backgroundColor: appColors.bgMuted,
                padding: "1rem 2rem",
                borderTop: `1px solid ${appColors.gray200}`,
                textAlign: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: appColors.landingSlateAlt,
                  mb: 1,
                }}
              >
                Güvenli bağlantı ile korunmaktadır
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
                <Typography variant="body2" sx={{ color: appColors.landingSlateAlt, display: "flex", alignItems: "center", gap: 0.5 }}>
                  🔒 SSL Güvenlik
                </Typography>
                <Typography variant="body2" sx={{ color: appColors.landingSlateAlt }}>•</Typography>
                <Typography variant="body2" sx={{ color: appColors.landingSlateAlt, display: "flex", alignItems: "center", gap: 0.5 }}>
                  🛡️ 256-bit Şifreleme
                </Typography>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default Register;